import styles from './index.scss'
import { useEffect, useRef, useState } from 'react'
import { useModel } from 'umi'
import { orderCouponList } from '@/services'
import Layout from '@/libs/components/Layout'
import iconSelected from '@/assets/image/xuanzhong.png'
import iconUnSelected from '@/assets/image/buxuanzhong.png'
import goTo from '@/libs/functions/goTo'
import { SelectDiscountCouponCard } from '@/libs/components/DiscountCouponCard'
import { SelectDisabledDiscountCouponCard } from '@/libs/components/DiscountCouponCard/disabled'
import { getUrlAllParams } from '@/libs/functions/getValue'
import { setStorage } from '@/libs/functions/onStorage'
import useCategorySet from '@/libs/hooks/useCategorySet'
import { generateCertificateStyleVars } from '@/libs/functions/generateCssVars'
import { SvgRadioSuccessIcon } from '@/libs/components/Icon/svgIcon'
import { TrackView } from '@dragonpass/intl-unified-tracker'

function UsableDiscountCoupon() {
  const {
    productNum,
    proCode,
    skuId,
    url,
    categoryType = 'GLOBAL',
    ...remainUrlParams
  } = getUrlAllParams() as any
  const { setQiankunGlobalState, qiankunGlobalState } = useModel(
    '@@qiankunStateForSlave',
  )
  const { discount } = qiankunGlobalState
  const [disableList, setDisableList] = useState<any>([]) // 不可用优惠券
  const [enableList, setEnableList] = useState<any>([]) // 可用优惠券
  const { categorySetting } = useCategorySet(categoryType)
  const customTextStyle = generateCertificateStyleVars(
    categorySetting.certificatePage,
  )
  useEffect(() => {
    getOrderCouponList()
    window.dpTracker?.sendPage({
      publicParams: {
        page_name: '我的优惠券',
      },
      eventData: {
        product_id: proCode,
        product_type: categoryType,
        equity_coupon_id: discount?.id,
      },
    })
  }, [])

  const getOrderCouponList = () => {
    orderCouponList({
      proCode: proCode,
      productNum: productNum,
      skuId,
      url,
      ...remainUrlParams,
    }).then((res: any) => {
      const { disableList, enableList } = res
      setDisableList(disableList)
      setEnableList(enableList)
    })
  }
  const onSelect = (discount: any) => {
    setQiankunGlobalState({
      discount,
    })
    // 卡券(SC/SSC)/实物(SW)：标记用户已手动选择优惠券(含“不使用”)，
    // 避免返回确认订单页时自动回显覆盖用户选择；其它品类不写标记、不受影响
    if (proCode && ['SC', 'SSC', 'SW'].includes(categoryType)) {
      setStorage('asset:manual', { proCode }, { storageType: 'session' })
    }
    discount.id &&
      setQiankunGlobalState({
        equity: {},
      }) // 置空权益
    goTo(-1)
  }

  return (
    <Layout title={'我的优惠券'}>
      <div className={styles.selectDiscount} style={customTextStyle}>
        <div className={styles.list}>
          <div
            className={styles.notUse}
            onClick={() =>
              onSelect({
                id: null,
                cuoName: '',
              })
            }
          >
            <div className={styles.text}>不使用优惠券</div>
            {discount?.id ? (
              <img src={iconUnSelected} className={styles.icon} />
            ) : (
              <SvgRadioSuccessIcon
                width={20}
                height={20}
                color={
                  categorySetting?.certificatePage?.primaryColor ||
                  'var(--certify-primary-color)'
                }
              />
            )}
          </div>
          {enableList.length > 0 &&
            enableList.map((v: any, idx) => (
              <SelectDiscountCouponCard
                color={
                  categorySetting?.certificatePage?.primaryColor ||
                  'var(--certify-primary-color)'
                }
                trackData={{
                  module_name: '选择优惠券',
                  activation_status: 1,
                  product_id: proCode,
                  product_type: categoryType,
                  equity_coupon_id: v?.id,
                  product_index: idx,
                }}
                trackClk={true}
                trackExp={true}
                categoryType={categoryType}
                onSelect={() => onSelect(v)}
                key={v.id}
                data={v}
                currencySymbol={v.currencySymbol || '¥'}
                check={v.id === discount?.id}
              />
            ))}
          <div className={styles.disabledSplit}>
            不可用优惠券{disableList.length}张
          </div>
          {disableList.length > 0 &&
            disableList.map((v: any, idx: number) => (
              <TrackView
                key={v.id}
                trackData={{
                  module_name: '选择优惠券',
                  activation_status: 0,
                  product_id: proCode,
                  product_type: categoryType,
                  equity_coupon_id: v?.id,
                  product_index: idx,
                }}
                trackClk={false}
                trackExp={true}
              >
                <SelectDisabledDiscountCouponCard
                  data={v}
                  currencySymbol={v.currencySymbol || '¥'}
                />
              </TrackView>
            ))}
          {disableList.length === 0 && (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              暂无可用优惠券
            </div>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default UsableDiscountCoupon
